// extracted by mini-css-extract-plugin
export var animationContainer = "_dj-0";
export var asteriskIcon = "_dj-8";
export var conversationLeftSection = "_dj-4";
export var conversationListItem = "_dj-3";
export var conversationMiddleSection = "_dj-5";
export var conversationRightSection = "_dj-6";
export var detailsContent = "_dj-1";
export var listContainer = "_dj-7";
export var modalContent = "_dj-2";